import SharedDialog from '../../../shared/shared-dialog';

interface ReportsRunDialogProps {
  open: boolean;
  onClose: () => void;
  reportName?: string;
  isRunning: boolean;
  onConfirm: () => void;
}

export default function ReportsRunDialog({
  open,
  onClose,
  reportName,
  isRunning,
  onConfirm,
}: Readonly<ReportsRunDialogProps>) {
  return (
    <SharedDialog
      open={open}
      handleClose={onClose}
      title="Run Report"
      dialogContent={
        <>
          Run <strong>{reportName}</strong>. This may take a few minutes
          depending on the data size.
        </>
      }
      primaryButton={{
        title: 'Run Report',
        action: onConfirm,
        loading: isRunning,
        disabled: isRunning,
      }}
    />
  );
}
